<template>
  <div>
    <!-- Header -->
    <b-row class="mb-2">
      <b-col cols="12">
        <h2 class="mb-0">
          {{ $t('settings.title') }}
        </h2>
        <p class="text-muted">
          {{ $t('settings.overview.description') }}
        </p>
      </b-col>
    </b-row>

    <!-- Settings Cards -->
    <b-row>
      <!-- Governorates Card -->
      <b-col
        cols="12"
        md="6"
        lg="4"
        class="mb-2"
      >
        <b-card
          class="settings-card cursor-pointer h-100"
          @click="navigateTo('settings-governorates')"
        >
          <div class="d-flex align-items-center">
            <b-avatar
              size="48"
              variant="light-primary"
              class="mr-2"
            >
              <feather-icon
                icon="MapIcon"
                size="24"
              />
            </b-avatar>
            <div class="flex-grow-1">
              <h4 class="mb-0">
                {{ $t('settings.governorates') }}
              </h4>
              <p class="text-muted mb-0">
                {{ $t('settings.overview.governorates_desc') }}
              </p>
            </div>
          </div>
        </b-card>
      </b-col>
      <!-- Centers Card -->
      <b-col
        cols="12"
        md="6"
        lg="4"
        class="mb-2"
      >
        <b-card
          class="settings-card cursor-pointer h-100"
          @click="navigateTo('settings-centers')"
        >
          <div class="d-flex align-items-center">
            <b-avatar
              size="48"
              variant="light-success"
              class="mr-2"
            >
              <feather-icon
                icon="MapPinIcon"
                size="24"
              />
            </b-avatar>
            <div class="flex-grow-1">
              <h4 class="mb-0">
                المراكز
              </h4>
              <p class="text-muted mb-0">
                ادارة المراكز
              </p>
            </div>
          </div>
        </b-card>
      </b-col>
      <!-- Cities Card -->
      <b-col
        cols="12"
        md="6"
        lg="4"
        class="mb-2"
      >
        <b-card
          class="settings-card cursor-pointer h-100"
          @click="navigateTo('settings-cities')"
        >
          <div class="d-flex align-items-center">
            <b-avatar
              size="48"
              variant="light-success"
              class="mr-2"
            >
              <feather-icon
                icon="MapPinIcon"
                size="24"
              />
            </b-avatar>
            <div class="flex-grow-1">
              <h4 class="mb-0">
                {{ $t('settings.cities') }}
              </h4>
              <p class="text-muted mb-0">
                {{ $t('settings.overview.cities_desc') }}
              </p>
            </div>
          </div>
        </b-card>
      </b-col>

      <!-- Districts Card -->
      <b-col
        cols="12"
        md="6"
        lg="4"
        class="mb-2"
      >
        <b-card
          class="settings-card cursor-pointer h-100"
          @click="navigateTo('settings-districts')"
        >
          <div class="d-flex align-items-center">
            <b-avatar
              size="48"
              variant="light-info"
              class="mr-2"
            >
              <feather-icon
                icon="NavigationIcon"
                size="24"
              />
            </b-avatar>
            <div class="flex-grow-1">
              <h4 class="mb-0">
                {{ $t('settings.districts') }}
              </h4>
              <p class="text-muted mb-0">
                {{ $t('settings.overview.districts_desc') }}
              </p>
            </div>
          </div>
        </b-card>
      </b-col>

      <!-- Authorities Card -->
      <b-col
        cols="12"
        md="6"
        lg="4"
        class="mb-2"
      >
        <b-card
          class="settings-card cursor-pointer h-100"
          @click="navigateTo('settings-authorities')"
        >
          <div class="d-flex align-items-center">
            <b-avatar
              size="48"
              variant="light-warning"
              class="mr-2"
            >
              <feather-icon
                icon="AwardIcon"
                size="24"
              />
            </b-avatar>
            <div class="flex-grow-1">
              <h4 class="mb-0">
                {{ $t('settings.authorities') }}
              </h4>
              <p class="text-muted mb-0">
                {{ $t('settings.overview.authorities_desc') }}
              </p>
            </div>
          </div>
        </b-card>
      </b-col>

      <!-- Engineering Offices Card -->
      <b-col
        cols="12"
        md="6"
        lg="4"
        class="mb-2"
      >
        <b-card
          class="settings-card cursor-pointer h-100"
          @click="navigateTo('settings-engineering-offices')"
        >
          <div class="d-flex align-items-center">
            <b-avatar
              size="48"
              variant="light-danger"
              class="mr-2"
            >
              <feather-icon
                icon="BriefcaseIcon"
                size="24"
              />
            </b-avatar>
            <div class="flex-grow-1">
              <h4 class="mb-0">
                {{ $t('settings.engineeringOffices') }}
              </h4>
              <p class="text-muted mb-0">
                {{ $t('settings.overview.engineering_offices_desc') }}
              </p>
            </div>
          </div>
        </b-card>
      </b-col>

      <!-- Attachment Lookups Card -->
      <b-col
        cols="12"
        md="6"
        lg="4"
        class="mb-2"
      >
        <b-card
          class="settings-card cursor-pointer h-100"
          @click="navigateTo('settings-attachment-lookups')"
        >
          <div class="d-flex align-items-center">
            <b-avatar
              size="48"
              variant="light-info"
              class="mr-2"
            >
              <feather-icon
                icon="PaperclipIcon"
                size="24"
              />
            </b-avatar>
            <div class="flex-grow-1">
              <h4 class="mb-0">
                مرفقات المعاملات
              </h4>
              <p class="text-muted mb-0">
                إدارة أنواع المرفقات المستخدمة في المعاملات
              </p>
            </div>
          </div>
        </b-card>
      </b-col>

      <!-- Service type attachment workflow slots -->
      <b-col
        cols="12"
        md="6"
        lg="4"
        class="mb-2"
      >
        <b-card
          class="settings-card cursor-pointer h-100"
          @click="navigateTo('settings-service-type-attachment-departments')"
        >
          <div class="d-flex align-items-center">
            <b-avatar
              size="48"
              variant="light-primary"
              class="mr-2"
            >
              <feather-icon
                icon="GitBranchIcon"
                size="24"
              />
            </b-avatar>
            <div class="flex-grow-1">
              <h4 class="mb-0">
                مسارات عمل المرفقات
              </h4>
              <p class="text-muted mb-0">
                أقسام مسار العمل لربط المرفقات بأنواع الخدمات
              </p>
            </div>
          </div>
        </b-card>
      </b-col>

      <!-- License Expiry Card -->
      <b-col
        cols="12"
        md="6"
        lg="4"
        class="mb-2"
      >
        <b-card
          class="settings-card cursor-pointer h-100"
          @click="navigateTo('settings-license-expiry')"
        >
          <div class="d-flex align-items-center">
            <b-avatar
              size="48"
              variant="light-secondary"
              class="mr-2"
            >
              <feather-icon
                icon="AlertCircleIcon"
                size="24"
              />
            </b-avatar>
            <div class="flex-grow-1">
              <h4 class="mb-0">
                {{ $t('settings.licenseExpiry.title') }}
              </h4>
              <p class="text-muted mb-0">
                {{ $t('settings.overview.license_expiry_desc') }}
              </p>
            </div>
          </div>
        </b-card>
      </b-col>
      <!-- License Expiry Card -->
      <b-col
        cols="12"
        md="6"
        lg="4"
        class="mb-2"
      >
        <b-card
          class="settings-card cursor-pointer h-100"
          @click="navigateTo('settings-customer-types')"
        >
          <div class="d-flex align-items-center">
            <b-avatar
              size="48"
              variant="light-secondary"
              class="mr-2"
            >
              <feather-icon
                icon="AlertCircleIcon"
                size="24"
              />
            </b-avatar>
            <div class="flex-grow-1">
              <h4 class="mb-0">
                {{ $t('settings.customerType.title') }}
              </h4>
              <p class="text-muted mb-0">
                {{ $t('settings.customerType.description') }}
              </p>
            </div>
          </div>
        </b-card>
      </b-col>
      <!-- License Expiry Card -->
      <b-col
        cols="12"
        md="6"
        lg="4"
        class="mb-2"
      >
        <b-card
          class="settings-card cursor-pointer h-100"
          @click="navigateTo('settings-statement-formulations')"
        >
          <div class="d-flex align-items-center">
            <b-avatar
              size="48"
              variant="light-secondary"
              class="mr-2"
            >
              <feather-icon
                icon="AlertCircleIcon"
                size="24"
              />
            </b-avatar>
            <div class="flex-grow-1">
              <h4 class="mb-0">
                صيغ البيان
              </h4>
              <p class="text-muted mb-0">
                ادارة صيغ البيان
              </p>
            </div>
          </div>
        </b-card>
      </b-col>
      <b-col
        cols="12"
        md="6"
        lg="4"
        class="mb-2"
      >
        <b-card
          class="settings-card cursor-pointer h-100"
          @click="navigateTo('settings-project-shape-schemas')"
        >
          <div class="d-flex align-items-center">
            <b-avatar
              size="48"
              variant="light-primary"
              class="mr-2"
            >
              <feather-icon
                icon="LayersIcon"
                size="24"
              />
            </b-avatar>
            <div class="flex-grow-1">
              <h4 class="mb-0">
                Project Shape Schemas
              </h4>
              <p class="text-muted mb-0">
                Manage shapefile attribute schemas
              </p>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BAvatar,
} from 'bootstrap-vue'

export default {
  name: 'SettingsOverview',
  components: {
    BRow,
    BCol,
    BCard,
    BAvatar,
  },
  methods: {
    navigateTo(routeName) {
      this.$router.push({ name: routeName })
    },
  },
}
</script>

<style lang="scss" scoped>
.settings-card {
  transition: all 0.3s ease;
  cursor: pointer;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.1);
  }
}

.cursor-pointer {
  cursor: pointer;
}
</style>
